const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Precision in Every Trade</h1>
        <p>
          Remove the guesswork and make informed trading decisions with ease.

          {/* Whether you’re hedging against inflation or capitalizing on short-term
          price shifts, The Pips provides an intuitive platform for both
          precision and performance. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
